module.exports = __webpack_public_path__ + "media/גל.aa0af746.mp3";